var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { log } from './log';
import { status } from './status';
import { getConfig } from './getConfig';
const debugFactory = (config) => {
    if (!(config && config.name && config.fColor && config.bColor)) {
        // in order not to break whomever is importing
        // return a function that can still be called
        return () => { };
    }
    const finalConfig = getConfig(config);
    const debug = (...args) => {
        const types = ['log', 'warn', 'error'];
        const length = args.length;
        if (length === 0) {
            // nothing to log
            return;
        }
        // debug('Look what happens.');
        if (finalConfig.shouldLog && length === 1 && typeof args[0] === 'string') {
            log(finalConfig, args[0]);
        }
        // debug('error', 'Oh no, there is an error.');
        if (finalConfig.shouldLog &&
            length === 2 &&
            ~types.indexOf(args[0]) &&
            typeof args[1] === 'string') {
            log(finalConfig, args[1], args[0]);
        }
        // debug('7845', 'Look what happens in this instance.');
        if (finalConfig.shouldLog &&
            length === 2 &&
            !~types.indexOf(args[0]) &&
            typeof args[1] === 'string' &&
            (typeof args[0] === 'string' || typeof args[0] === 'number')) {
            log(finalConfig, args[1], undefined, args[0]);
        }
        // debug('error', '7845', 'Oh no, there is an error in this instance.');
        if (finalConfig.shouldLog &&
            length === 3 &&
            ~types.indexOf(args[0]) &&
            (typeof args[1] === 'string' || typeof args[1] === 'number') &&
            typeof args[2] === 'string') {
            log(finalConfig, args[2], args[0], args[1]);
        }
        // debug({message: 'Oh no', type: 'error', subName: '7845'});
        if (length === 1 && typeof args[0] === 'object') {
            const obj = args[0];
            const { message, state, type, subName } = obj, data = __rest(obj, ["message", "state", "type", "subName"]);
            if (finalConfig.shouldLog && message) {
                log(finalConfig, message, type, subName, data);
            }
            if (state) {
                status(finalConfig, state, data);
            }
        }
    };
    return debug;
};
/**
 * Find out whether to log or not
 * @param serviceName The name of a service used in URL param sznivadbg
 * @returns To log or not to log, that is the question
 */
const shouldLog = (serviceName) => getConfig({ name: serviceName }).shouldLog;
export { debugFactory, shouldLog };
